import React, { useState, useEffect } from "react";
import {
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Row,
    Col,
    Label
} from "reactstrap";

import { connect } from "react-redux";
import { Button, Select, MenuItem } from "@material-ui/core";

import { selectAllEquipmentTypes } from "../selectors";
import { getEquipmentTypes } from "../actions";

import styled from "styled-components";

const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;

const AddEditModal = props => {
    const [isOpen, setModalState] = useState(props.isOpen);
    const [category, setCatagory] = useState("Default");
    const [selectedQRs, setSelectedQRs] = useState(props.selectedQRs);
    const [equ, setEquipmentTypes] = useState(props.equipmentTypes);

    useEffect(() => {
        setModalState(props.isOpen);
        setEquipmentTypes(props.equipmentTypes);
        setSelectedQRs(props.selectedQRs);
    }, [props.isOpen, props.equipmentTypes, props.selectedQRs]);

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader>Change Selected Equipment Catagories</ModalHeader>
            <ModalBody>
                <ModalRow>
                    <Col>
                        <Label for="category">Category</Label>
                        <Select
                            id="category"
                            value={category}
                            style={{ width: "100%" }}
                            onChange={event => {
                                setCatagory(event.target.value);
                            }}
                        >
                            {equ &&
                                equ.map((equipmentTypes, key) => {
                                    return (
                                        <MenuItem
                                            key={key}
                                            value={equipmentTypes}
                                        >
                                            {equipmentTypes}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </Col>
                </ModalRow>
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => props.close()} variant="contained">
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        selectedQRs.map(e => {
                            props.updateCatagory(e, category);
                            return null;
                        });
                        props.close();
                    }}
                    variant="contained"
                    color="primary"
                >
                    Update
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default connect(
    store => {
        return {
            equipmentTypes: selectAllEquipmentTypes(store)
        };
    },
    { getEquipmentTypes }
)(AddEditModal);
//export default AddEditModal;
